import React from 'react';

import TOR_STATUSES, { TOR_STATUS_LABELS } from './TOR_STATUSES';
import { formatIsoToDate } from '../../../utils';

const columnTextNoWrap = 'align-middle text-nowrap';

const DriverNameHeader = () => (
  <div>
    <div>Driver Name & Number</div>
    <div>Customer</div>
  </div>
);

const DriverNameCell = ({ row }) => (
  <div>
    <div>
      {row.original.employeeName && row.original.employeeId ?
        `${row.original.employeeName} - ${row.original.employeeId}` : `${row.original.employeeId}`}
    </div>
    <div style={{ marginTop: 2 }}>
      {row.original.customerName && row.original.customerId
        ? `${row.original.customerName} - ${row.original.customerId}`
        : row.original.customerName
          ? row.original.customerName
          : row.original.customerId
            ? `0 - ${row.original.customerId}`
            : 'No active contract activity'}
    </div>
  </div>
);

const columns = {
  [TOR_STATUSES.PENDING_APPROVAL]: [
    {
      Header: 'Date Entered',
      accessor: 'createdAt',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: DriverNameHeader,
      accessor: 'employeeName',
      className: columnTextNoWrap,
      Cell: DriverNameCell,
      disableSortBy: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      className: columnTextNoWrap,
      disableSortBy: false,
    },
    {
      Header: () => (
        <div>
          <div>Driver Note</div>
          <div style={{ fontSize: '0.85em', fontWeight: 'normal' }}>Service Comment</div>
        </div>
      ),
      accessor: 'employeeComment',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => (
        <div>
          {row.original.employeeComment && <div>{row.original.employeeComment}</div>}
          {row.original.serviceComment && (
            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>{row.original.serviceComment}</div>
          )}
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => TOR_STATUS_LABELS[instance.value] || instance.value,
    },
  ],
  [TOR_STATUSES.APPROVED]: [
    {
      Header: 'Date Entered',
      accessor: 'createdAt',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: DriverNameHeader,
      accessor: 'employeeName',
      className: columnTextNoWrap,
      Cell: DriverNameCell,
      disableSortBy: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      className: columnTextNoWrap,
      disableSortBy: false,
    },
    {
      Header: () => (
        <div>
          <div>Driver Note</div>
          <div style={{ fontSize: '0.85em', fontWeight: 'normal' }}>Service Comment</div>
        </div>
      ),
      accessor: 'employeeComment',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => (
        <div>
          {row.original.employeeComment && <div>{row.original.employeeComment}</div>}
          {row.original.serviceComment && (
            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>{row.original.serviceComment}</div>
          )}
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => TOR_STATUS_LABELS[instance.value] || instance.value,
    },
    {
      Header: 'Approved by',
      accessor: 'approvedByUserName',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => row.original.approvedByUserName,
    },
  ],
  [TOR_STATUSES.DECLINED]: [
    {
      Header: 'Date Entered',
      accessor: 'createdAt',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: DriverNameHeader,
      accessor: 'employeeName',
      className: columnTextNoWrap,
      Cell: DriverNameCell,
      disableSortBy: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      className: columnTextNoWrap,
      disableSortBy: false,
    },
    {
      Header: () => (
        <div>
          <div>Driver Note</div>
          <div style={{ fontSize: '0.85em', fontWeight: 'normal' }}>Service Comment</div>
        </div>
      ),
      accessor: 'employeeComment',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => (
        <div>
          {row.original.employeeComment && <div>{row.original.employeeComment}</div>}
          {row.original.serviceComment && (
            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>{row.original.serviceComment}</div>
          )}
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => TOR_STATUS_LABELS[instance.value] || instance.value,
    },
    {
      Header: 'Declined by',
      accessor: 'declinedByUserName',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => row.original.declinedByUserName,
    },
  ],
  [TOR_STATUSES.CANCELLED]: [
    {
      Header: 'Date Entered',
      accessor: 'createdAt',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: DriverNameHeader,
      accessor: 'employeeName',
      className: columnTextNoWrap,
      Cell: DriverNameCell,
      disableSortBy: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      className: columnTextNoWrap,
      disableSortBy: false,
    },
    {
      Header: () => (
        <div>
          <div>Driver Note</div>
          <div style={{ fontSize: '0.85em', fontWeight: 'normal' }}>Service Comment</div>
        </div>
      ),
      accessor: 'employeeComment',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => (
        <div>
          {row.original.employeeComment && <div>{row.original.employeeComment}</div>}
          {row.original.serviceComment && (
            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>{row.original.serviceComment}</div>
          )}
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => TOR_STATUS_LABELS[instance.value] || instance.value,
    },
    {
      Header: 'Cancelled by',
      accessor: 'cancelledByUserName',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => row.original.cancelledByUserName,
    },
  ],
  [TOR_STATUSES.SEARCH]: [
    {
      Header: 'Date Entered',
      accessor: 'createdAt',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: DriverNameHeader,
      accessor: 'employeeName',
      className: columnTextNoWrap,
      Cell: DriverNameCell,
      disableSortBy: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: instance => formatIsoToDate(instance.value),
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      className: columnTextNoWrap,
      disableSortBy: false,
    },
    {
      Header: () => (
        <div>
          <div>Driver Note</div>
          <div style={{ fontSize: '0.85em', fontWeight: 'normal' }}>Service Comment</div>
        </div>
      ),
      accessor: 'employeeComment',
      className: columnTextNoWrap,
      disableSortBy: false,
      Cell: ({ row }) => (
        <div>
          {row.original.employeeComment && <div>{row.original.employeeComment}</div>}
          {row.original.serviceComment && (
            <div style={{ fontSize: '0.85em', color: '#666', marginTop: 4 }}>{row.original.serviceComment}</div>
          )}
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      className: columnTextNoWrap,
      Cell: ({ row }) => {
        const { status, approvedByUserName, declinedByUserName, cancelledByUserName } = row.original;
        let displayName = '';
        if (status === TOR_STATUSES.APPROVED && approvedByUserName) {
          displayName = approvedByUserName;
        } else if (status === TOR_STATUSES.DECLINED && declinedByUserName) {
          displayName = declinedByUserName;
        } else if (status === TOR_STATUSES.CANCELLED && cancelledByUserName) {
          displayName = cancelledByUserName;
        }
        return (
          <div>
            {TOR_STATUS_LABELS[status] || status}
            {displayName && <div style={{ fontSize: '0.85em' }}>{displayName}</div>}
          </div>
        );
      },
      disableSortBy: false,
    },
  ],
};

export default columns;
